import injectScript from '../document/inject-script';

export default async function injectHubspotScript(hubspot_token: string) {
  try {
    await injectScript(`//js.hs-scripts.com/${hubspot_token}.js`, 'hs-script-loader');
  } catch (error) {
    return Promise.reject(error);
  }
}
